import { render, staticRenderFns } from "./DefaultSection.vue?vue&type=template&id=fd883490&scoped=true"
import script from "./DefaultSection.vue?vue&type=script&lang=js"
export * from "./DefaultSection.vue?vue&type=script&lang=js"
import style0 from "./DefaultSection.vue?vue&type=style&index=0&id=fd883490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd883490",
  null
  
)

export default component.exports